import React from "react";

import logo from "../../images/logo_white.svg";

import "./index.css";

const FOOTER_LINKS = [
  { label: "Company", href: "https://4basecare.com/" },
  { label: "About Us", href: "https://4basecare.com/about-us/overview/" },
  { label: "Terms & Conditions", href: "https://4basecare.com/terms-of-use/" },
  { label: "Contact Us", href: "https://4basecare.com/contact-us/" },
];

const Footer = ({ className = "", title = "Global Cancer Diversity Atlas" }) => (
  <div className={`footer_bg ${className}`}>
    <div className="footer_section cust_space">
      <div className="footer_right">
        <ul className="list-unstyled">
          {FOOTER_LINKS.map(({ label, href }) => (
            <li key={label}>
              <a href={href} target="_blank" rel="noopener noreferrer">
                {label}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div className="footer_left d-flex">
        <h4 className="mb-0">
          <b>{title}</b> <span>by</span>
        </h4>
        <img className="pl-2" alt="" src={logo} />
      </div>
    </div>
  </div>
);

export default Footer;
